import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';

import ArrayProxy from '@ember/array/proxy';
import ApiCredentialsService from 'cio/services/api-credentials';
import CustomerioController from 'cio/pods/integrations/customerio/controller';
import ApiCredentialModel from 'cio/models/api-credential';

export default class CustomerioRoute extends Route {
  @service apiCredentials!: ApiCredentialsService;

  crumb() {
    return {
      name: 'Customer.io',
      path: 'integrations.customerio',
    };
  }

  model() {
    return this.apiCredentials.loadCurrentEnvironmentCredentials.perform();
  }

  setupController(controller: CustomerioController, model: ArrayProxy<ApiCredentialModel>) {
    controller.selectedCredential = model.length === 1 ? model.firstObject! : null;
  }
}
